import { PageHero } from "@/components/Sections";

export default function Privacy() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Privacy"
        accent="Policy."
        subtitle="How Bronto Cosmos handles information when you use this website."
      />
      <section className="max-w-3xl mx-auto px-6 pb-24 text-white/75 leading-relaxed space-y-6 text-[15px]">
        <p>Last updated: February 2026.</p>
        <h2 className="display text-2xl text-white">Overview</h2>
        <p>Bronto Cosmos is a discovery platform operated by Bronto Intelligence Private Limited. This policy describes the information we collect and how it is used.</p>
        <h2 className="display text-2xl text-white">Information we collect</h2>
        <p>Bronto Cosmos does not require accounts or sign-ups to use the platform. When you use the contact form, we collect the name, email address, and message you submit, along with limited technical metadata (such as user agent and IP address) for spam prevention and operational diagnostics. We may also collect anonymized analytics about usage of the website (pages viewed, device type, country).</p>
        <h2 className="display text-2xl text-white">How we use information</h2>
        <p>Information submitted through the contact form is used only to respond to your inquiry and is routed to info@brontointelligence.com. Analytics information is used to improve the website and is processed in aggregate. We do not sell personal information.</p>
        <h2 className="display text-2xl text-white">Third-party services</h2>
        <p>The platform displays open cosmic imagery and data from established scientific sources. These third-party services have their own privacy policies, which apply to information they receive.</p>
        <h2 className="display text-2xl text-white">Advertising</h2>
        <p>Bronto Cosmos may, in the future, display advertisements through services such as Google AdSense. If advertising is enabled, the advertising provider may use cookies and similar technologies to serve relevant ads. Disclosure will be updated here at the time of activation.</p>
        <h2 className="display text-2xl text-white">Children</h2>
        <p>Bronto Cosmos is intended for a general audience and does not knowingly collect personal information from children under the age of 13.</p>
        <h2 className="display text-2xl text-white">Contact</h2>
        <p>Questions about this policy can be sent to info@brontointelligence.com.</p>
      </section>
    </>
  );
}
